import { RootState } from './store';

export const selectScreenState = (state: RootState) =>
  state.screenStateSelector;

export const selectApplicationScreenSelector = (state: RootState) =>
  state.applicationScreenSelector;

export const selectLoginSelector = (state: RootState) => state.loginSelector;

export const selectAppStatus = (state: RootState) =>
  state.applicationStatusSelector;

export const selectConsumerProfile = (state: RootState) =>
  state.consumerInfoSelector.consumerProfile;

export const selectApiScreenState = (state: RootState) =>
  state.apiScreenScreenSelector;
